<template>
  <div>
    <div class="date-switch-wrap">
      <date-switcher
        @switch="handleRangeChange"
        rangeType="week"
        :immediate="true"
      ></date-switcher>
    </div>
    <el-table
      size="mini"
      :data="tableData"
      stripe
      v-horizontal-scroll
      style="width: 100%"
      tooltip-effect="dark"
      @sort-change="handleSortChange"
      :default-sort="{ prop: 'date', order: 'descending' }"
    >
      <el-table-column label="排课模式">
        <template slot-scope="scope">
          <span v-if="!scope.row.arrange">自由</span>
          <span
            v-else-if="scope.row.arrange && scope.row.arrange.cycle_type === 1"
            >按日</span
          >
          <span v-if="scope.row.arrange && scope.row.arrange.cycle_type === 2"
            >按周</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="上课时间"
        prop="date"
        width="300"
        sortable="custom"
        :sort-orders="['ascending', 'descending']"
      >
        <template slot-scope="scope"
          >{{
            getTime(new Date(scope.row.date)) +
            " " +
            scope.row.start_time.slice(0, 5)
          }}~{{ scope.row.end_time.slice(0, 5) }}</template
        >
      </el-table-column>
      <el-table-column label="授课教师">
        <template slot-scope="scope">
          <span
            class="dot"
            v-for="item in scope.row.teacher_list"
            :key="item.teacher_id"
            >{{ item.name }}</span
          >
          <span v-if="scope.row.teacher_list.length === 0">-</span>
        </template>
      </el-table-column>
      <el-table-column label="授课模式">
        <template slot-scope="scope">
          <span v-if="scope.row.lesson_type === 1">线下</span>
          <span v-if="scope.row.lesson_type === 2">线上</span>
        </template>
      </el-table-column>
      <el-table-column label="上课教室">
        <template slot-scope="scope">
          {{ scope.row.classroom ? scope.row.classroom.name : "-" }}
        </template>
      </el-table-column>
      <el-table-column label="排课课程">
        <template slot-scope="scope">{{ scope.row.course.title }}</template>
      </el-table-column>
      <el-table-column label="上课内容" class-name="classCon" width="300">
        <template slot-scope="scope">
          <span v-if="scope.row.class_lesson_extend.content">
            {{ scope.row.class_lesson_extend.content }}
          </span>
          <span v-else> - </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="200" align="left">
        <template slot-scope="scope">
          <el-button
            class="mwow-button success"
            @click="handleSign(scope.row)"
            v-if="scope.row.in_holiday === 2"
            >点名</el-button
          >
          <el-button class="mwow-button success" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button class="mwow-button danger" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ display: 'flex', 'justify-content': 'end', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
    <!-- 课时编辑 -->
    <el-drawer
      title="课时编辑"
      :visible.sync="lessonDialogVisible"
      direction="rtl"
      :size="550"
      destroy-on-close
    >
      <lesson-dialog
        :lid="lessonDialogId"
        :visible.sync="lessonDialogVisible"
        :calssContent="lessonClassContent"
        @change="handleRefresh"
      ></lesson-dialog>
    </el-drawer>
  </div>
</template>
<script>
import eventBus from "@/utils/bus";
import dateSwitcher from "@/components/dateSwitcher.vue";
import { getlessonlist } from "@/api/studyDetails";
import { deleteLesson } from "@/api/lesson";
import { dateFormat } from "@/utils/timeFormat";
import lessonDialog from "./lessonEditDialog.vue";

export default {
  name: "classDetailUnsigned",
  components: {
    dateSwitcher,
    lessonDialog,
  },
  data() {
    return {
      tableData: [],
      startDate: "",
      endDate: "",
      page: 1,
      pageSize: 10,
      pageSizeArray: [5, 10, 30, 50, 100],
      total: 0,
      lessonDialogVisible: false,
      lessonDialogId: 0,
      lessonClassContent: "",
      sort_type: "desc",
      sort_field: "full_start_time",
    };
  },

  created() {
    eventBus.$on("class-listing-update", () => {
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    });
  },
  methods: {
    // 排序请求
    handleSortChange(a) {
      if (a.order == "descending") {
        this.sort_type = "desc";
      } else if (a.order == "ascending") {
        this.sort_type = "asc";
      } else {
        this.sort_type = "";
      }
      this.getList({
        page: this.page,
        page_size: this.pageSize,
      });
    },
    getTime(e) {
      const weekZh = ["日", "一", "二", "三", "四", "五", "六"];
      const v = "（周" + weekZh[e.getDay()] + "）";
      const format = dateFormat("YYYY-mm-dd", e);
      return format.slice(0, 10) + v + format.slice(11);
    },
    getList(params) {
      const cid = this.$route.query.id;
      if (cid) {
        const opt = {
          page: params.page,
          page_size: params.page_size,
          start_date: this.startDate,
          end_date: this.endDate,
          class_id: Number(cid),
          roll_call_status: 1,
          sort_field: this.sort_field,
          sort_type: this.sort_type,
        };
        getlessonlist(opt).then((res) => {
          if (res.error_code === 0) {
            this.tableData = res.data.list;
            this.total = res.data.total;
            this.page = params.page;
          }
        });
      }
    },
    handleRangeChange(data) {
      this.startDate = dateFormat("YYYY-mm-dd", new Date(data[0]));
      this.endDate = dateFormat("YYYY-mm-dd", new Date(data[1]));
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleRefresh(type) {
      let page = this.page;
      if (
        type === "delete" &&
        (this.page - 1) * this.pageSize + 1 === this.total
      ) {
        page = page - 1;
      }
      this.getList({
        page: page > 0 ? page : 1,
        page_size: this.pageSize,
      });
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    handleEdit(row) {
      this.lessonDialogId = row.lesson_id;
      this.lessonDialogVisible = true;
      this.lessonClassContent = row.class_lesson_extend.content;
    },
    handleDelete(row) {
      this.$confirm(
        "删除后，班级学员对应的课时都将自动删除，不能恢复。",
        `删除`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          iconClass: "mwow-icon-error",
        }
      )
        .then(() => {
          const cid = Number(this.$route.query.id);
          deleteLesson({
            lesson_ids: [row.lesson_id],
            class_id: cid,
          }).then((res) => {
            if (res.error_code === 0) {
              this.handleRefresh("delete");
              eventBus.$emit("unsigned-list-update");
            }
          });
        })
        .catch(() => {});
    },
    handleSign(row) {
      this.$router.push({
        name: "classTimeDetails",
        query: { id: row.lesson_id },
      });
    },
    beforeDestroy() {
      eventBus.$off("class-listing-update");
    },
  },
};
</script>
<style lang="scss" scoped>
.date-switch-wrap {
  margin-bottom: 13px;
}
.dot {
  &::after {
    content: "、";
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
}
/deep/.el-table {
  th {
    &.is-sortable {
      .caret-wrapper {
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 1;
        }
      }
    }
  }
}
/deep/ .classCon {
  .cell {
    width: 22em;
    overflow: hidden; /*超出部分隐藏*/
    white-space: nowrap; /*禁止换行*/
    text-overflow: ellipsis;
  }
}
</style>
